import {
  Avatar,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import TankerIcon from 'assets/membership-features/tanker.svg?react';
import {
  MEMBERSHIP_PLANS,
  MEMBERSHIP_PLANS_AMOUNTS,
} from 'features/membership/membership.constants';
import { getPaywallLink } from 'features/membership/membership.utils';

export const MembershipSuggestion = (): JSX.Element => {
  const { t } = useTranslation();

  const paywallLink = getPaywallLink({
    focusedPlan: MEMBERSHIP_PLANS.yearly,
    source: 'donate_page',
  });

  return (
    <Card
      elevation={0}
      sx={{
        bgcolor: 'background.membership',
        borderRadius: '16px',
        alignSelf: 'center',
        maxWidth: '90%',
      }}
    >
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar
              sx={{
                bgcolor: 'background.paper',
                width: 42,
                height: 42,
                '& rect': (theme) => ({
                  fill: theme.palette.background.paper,
                }),
              }}
            >
              <TankerIcon width="100%" height="100%" />
            </Avatar>

            <Typography sx={{ lineHeight: '22px' }}>
              {t('donate.card.message')}
            </Typography>
          </Stack>

          <Button
            fullWidth
            size="large"
            variant="outlined"
            color="neutral"
            sx={{ textTransform: 'none' }}
            component={Link}
            to={paywallLink.url}
          >
            {t('donate.card.becomeAMember', {
              price: MEMBERSHIP_PLANS_AMOUNTS.yearly,
            })}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
